export const data = [
  {
    SerialNum: '1',
    col1: 'Value',
    col2: 'Value',
    col3: 'Value',
    col4: 'Value',
    col5: 'Value',
    col6: 'Value',
    col7: 'Value',
  },
  {
    SerialNum: '2',
    col1: 'Value',
    col2: 'Value',
    col3: 'Value',
    col4: 'Value',
    col5: 'Value',
    col6: 'Value',
    col7: 'Value',
  },
  {
    SerialNum: '3',
    col1: 'Value',
    col2: 'Value',
    col3: 'Value',
    col4: 'Value',
    col5: 'Value',
    col6: 'Value',
    col7: 'Value',
  },
  {
    SerialNum: '4',
    col1: 'Value',
    col2: 'Value',
    col3: 'Value',
    col4: 'Value',
    col5: 'Value',
    col6: 'Value',
    col7: 'Value',
  },
  {
    SerialNum: '5',
    col1: 'Value',
    col2: 'Value',
    col3: 'Value',
    col4: 'Value',
    col5: 'Value',
    col6: 'Value',
    col7: 'Value',
  },
  {
    SerialNum: '6',
    col1: 'Value',
    col2: 'Value',
    col3: 'Value',
    col4: 'Value',
    col5: 'Value',
    col6: 'Value',
    col7: 'Value',
  },
]

export const flexMapperWithIndex: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
  9: 1,
  10: 1,
  11: 1,
}

export const headerData = [
  {
    title: 'Sr.No.',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
]
